import React, { Component } from "react";
import styles from "./index.module.less"
import { DarkModal } from "@/components/Modal";
import darkControl from "@/components/Modal/darkControl.module.less";
import DeviceInfo from "./DeviceInfo";

class Index extends Component {
    render() {
        const { visible, onClose, ...par } = this.props;
        return (
            <DarkModal
                className={darkControl.darkControl}
                title={'设备详情'}
                centered
                visible={visible}
                onCancel={_ => { onClose && onClose() }}
                footer={null}
                width={`10rem`}
                destroyOnClose={true}
            >
                <div className={styles.main} >
                    <DeviceInfo {...par} />
                </div>
            </DarkModal >
        )
    }
}
export default Index